/**
 * Shared symbol used to tag a thrown error with a call-scoped retry boundary,
 * so BifrostWeb can attach retry-wait behaviour that RetryManager later reads
 * off the error without either module needing to import the other.
 */
export const CALL_RETRY_BOUNDARY = Symbol.for(
  "@seekrtech/bifrost/call-retry-boundary",
);
